import React from 'react';
import { useParams } from 'react-router-dom';
import EnhancedClinicalNotes from '../../components/ClinicalNotes/EnhancedClinicalNotes';

const ClinicalNotes = ({ patientId: propPatientId, role = 'doctor' }) => {
  const { id: paramPatientId } = useParams();
  const finalPatientId = propPatientId || paramPatientId;

  return (
    <EnhancedClinicalNotes patientId={finalPatientId} role={role} />
  );
};

export default ClinicalNotes; 